(function () {
  function initSlideshow(root) {
    if (root.getAttribute('data-brb-ready')) { return; }
    root.setAttribute('data-brb-ready', 'true');

    var track = root.querySelector('[data-brb-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-brb-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-brb-dot]'));
    var prevBtn = root.querySelector('[data-brb-prev]');
    var nextBtn = root.querySelector('[data-brb-next]');
    var pauseBtn = root.querySelector('[data-brb-pause]');
    var count = slides.length;
    if (!track || !count) { return; }

    var delay = parseInt(root.getAttribute('data-delay'), 10) || 6000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reduceMotion;
    if (autoplay) { root.classList.add('brb-slides--auto'); }
    else if (pauseBtn) { pauseBtn.hidden = true; }

    var videos = slides.map(function (slide) { return slide.querySelector('[data-brb-video]'); });
    var hasVideo = videos.some(Boolean);
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };

    var current = 0;
    var timer = null;
    var startedAt = 0;
    var remaining = delay;
    var moving = false;
    var idleTimer = null;
    var resizeTimer = null;
    var hold = { user: false, hover: false, focus: false, touch: false, hidden: false, offscreen: false, editor: false };

    /* Video slides can set their own time on screen */
    function slideDelay(index) {
      var d = parseInt(slides[index].getAttribute('data-duration'), 10);
      return d > 0 ? d : delay;
    }
    function applyDelay(index) {
      remaining = slideDelay(index);
      root.style.setProperty('--brb-delay', (remaining / 1000) + 's');
    }

    function isHeld() {
      return hold.user || hold.hover || hold.focus || hold.touch || hold.hidden || hold.offscreen || hold.editor;
    }
    function stop() {
      if (timer) { window.clearTimeout(timer); timer = null; }
    }
    function schedule() {
      stop();
      if (!autoplay || isHeld() || moving) { return; }
      startedAt = Date.now();
      timer = window.setTimeout(function () { timer = null; goTo(current + 1); }, remaining);
    }

    /* Looping background video: only the visible slide plays; others pause */
    function videoAllowed() {
      return hasVideo && !reduceMotion && !hold.user && !hold.hidden && !hold.offscreen;
    }
    function loadVideo(index) {
      var video = videos[index];
      if (!video || video.getAttribute('data-loaded')) { return; }
      var src = (mobileMq.matches ? video.getAttribute('data-src-m') : video.getAttribute('data-src-d')) || video.getAttribute('data-src-d');
      if (!src) { return; }
      video.src = src.trim();
      video.setAttribute('data-loaded', 'true');
      video.load();
    }
    function playVideos() {
      if (!hasVideo) { return; }
      var allowed = videoAllowed();
      videos.forEach(function (video, k) {
        if (!video) { return; }
        if (k === current && allowed) {
          loadVideo(k);
          var played = video.play();
          if (played && played.catch) { played.catch(function () {}); }
        } else {
          video.pause();
        }
      });
      if (allowed) { loadVideo((current + 1) % count); }
    }
    videos.forEach(function (video) {
      if (video) { video.addEventListener('playing', function () { video.classList.add('is-playing'); }); }
    });

    function sync() {
      var held = isHeld();
      root.classList.toggle('is-paused', held);
      if (held) {
        if (timer) { remaining = Math.max(800, remaining - (Date.now() - startedAt)); stop(); }
      } else if (!timer) {
        schedule();
      }
      playVideos();
    }
    function nearestIndex() {
      var width = track.clientWidth || 1;
      return Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / width)));
    }
    function setCurrent(index) {
      current = index;
      dots.forEach(function (dot, k) {
        var on = k === index;
        dot.classList.toggle('is-current', on);
        dot.classList.remove('is-active');
        if (on) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
      });
      root.setAttribute('data-tone', slides[index].getAttribute('data-tone') || 'white');
      playVideos();
    }
    function settle() {
      var index = nearestIndex();
      if (index !== current) { setCurrent(index); }
      moving = false;
      slides.forEach(function (slide, k) { slide.classList.toggle('is-active', k === current); });
      dots.forEach(function (dot, k) { dot.classList.toggle('is-active', k === current); });
      applyDelay(current);
      stop();
      sync();
    }
    function goTo(index, instant) {
      var target = (index + count) % count;
      var width = track.clientWidth;
      stop();
      if (target === current && Math.abs(track.scrollLeft - target * width) < 2) { settle(); return; }
      moving = true;
      var wraps = count > 2 && Math.abs(target - current) === count - 1;
      if (wraps && !instant) {
        track.classList.add('is-fading');
        window.setTimeout(function () {
          track.scrollTo({ left: target * track.clientWidth, behavior: 'auto' });
          track.classList.remove('is-fading');
        }, 230);
      } else {
        track.scrollTo({ left: target * width, behavior: instant ? 'auto' : 'smooth' });
      }
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(settle, 900);
    }

    track.addEventListener('scroll', function () {
      moving = true;
      stop();
      var index = nearestIndex();
      if (index !== current) { setCurrent(index); }
      window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(settle, 140);
    }, { passive: true });

    dots.forEach(function (dot, k) { dot.addEventListener('click', function () { goTo(k); }); });
    if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(current - 1); }); }
    if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(current + 1); }); }
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        hold.user = !hold.user;
        pauseBtn.setAttribute('aria-pressed', hold.user ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', hold.user ? 'Play slideshow' : 'Pause slideshow');
        sync();
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { goTo(current - 1); }
      else if (event.key === 'ArrowRight') { goTo(current + 1); }
    });

    /* Pause so people can read: hover (mouse only), keyboard focus, finger down, hidden tab, off screen */
    root.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') { hold.hover = true; sync(); } });
    root.addEventListener('pointerleave', function (event) { if (event.pointerType === 'mouse') { hold.hover = false; sync(); } });
    root.addEventListener('focusin', function (event) {
      if (event.target.matches && event.target.matches(':focus-visible')) { hold.focus = true; sync(); }
    });
    root.addEventListener('focusout', function () { hold.focus = false; sync(); });
    root.addEventListener('touchstart', function () { hold.touch = true; sync(); }, { passive: true });
    root.addEventListener('touchend', function () { hold.touch = false; sync(); }, { passive: true });
    root.addEventListener('touchcancel', function () { hold.touch = false; sync(); }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (!root.isConnected) { return; }
      hold.hidden = document.hidden;
      sync();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        hold.offscreen = !entries[0].isIntersecting;
        sync();
      }, { threshold: 0.3 }).observe(root);
    }

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (!root.isConnected) { return; }
        track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
      }, 150);
    });

    /* Theme editor: jump to the slide being edited and hold autoplay */
    root.addEventListener('shopify:block:select', function (event) {
      var index = slides.indexOf(event.target);
      if (index > -1) { hold.editor = true; goTo(index, true); }
    });
    root.addEventListener('shopify:block:deselect', function () { hold.editor = false; sync(); });

    applyDelay(0);
    sync();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-brb-slides]'), initSlideshow);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }
})();
